import qs from 'qs';
export var encodeUrlParam = function encodeUrlParam(data) {
  return qs.stringify(data, {
    allowDots: true,
    arrayFormat: 'indices'
  });
};
export var decodeUrlParam = function decodeUrlParam(url) {
  return qs.parse(url);
};
export var isEmpty = function isEmpty(value) {
  return Array.isArray(value) ? value.length === 0 : value === undefined || value === null || value === '';
};

/**
 * 返回基础类型
 * @param a
 * @returns Object|Array|String|Number|Boolean|Null|Undefined
 */
export var getType = function getType(a) {
  return {}.toString.call(a).slice(8, -1);
};
export var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};